var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DragPanel',[_c('div',{staticClass:"detail-panel"},_vm._l((_vm.infoData),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('span',[_vm._v(_vm._s(item.key)+":")]),_c('span',[_vm._v(_vm._s(item.value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }